import { render } from "./App.vue?vue&type=template&id=d4dd8440&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=d4dd8440&lang=scss"

import exportComponent from "C:\\Users\\kevintam\\Documents\\pokeraudit\\pokeraudit\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__